import React, { useEffect, useState } from "react";
import { Popover } from "antd";
import { useLocation, useNavigate } from "react-router";
import FirebaseManager from "../../../firebase/FirebaseManager";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import { useRecoilState } from "recoil";
import { notificationPermission } from "../../../components/recoil/notificationPermissioRecoil";

const firebaseConfig = {
  apiKey: "AIzaSyDdiDg_wQ2tvt0mfRRF40EWvZt64M9qP-U",
  authDomain: "niramaya-dev-7c92a.firebaseapp.com",
  projectId: "niramaya-dev-7c92a",
  storageBucket: "niramaya-dev-7c92a.firebasestorage.app",
  messagingSenderId: "746980513133",
  appId: "1:746980513133:web:31677ef036269c2401b664",
};

const VAPID_KEY =
  "BDateYAN4-Vmb7FCYY_kaE6jq9uCLz4svol6WlKLOKM5aNgc5KjtJ3-YvM3DGVfRzsu2uZF9vrrlewPcrY6CVvY";

const EnableNotificationIcon = () => {
  const location = useLocation();
  const isHomePage = location.pathname.endsWith("/homepage");
  const [permission, setPermission] = useRecoilState(notificationPermission);
  const navigate = useNavigate();
  const userJson = useReadMemory(MemoryType.USER);
  const [firebaseManager, setFirebaseManager] = useState(null);
  const [isSupported, setIsSupported] = useState(null);

  useEffect(() => {
    if (!isHomePage) return;

    const checkBrowserSupportNotification = async () => {
      if (!("Notification" in window)) {
        setIsSupported(false);
        return;
      }
      try {
        const supported = await FirebaseManager.isBrowserSupported();
        setIsSupported(supported);
        if (supported) {
          setFirebaseManager(
            (prev) =>
              prev ||
              new FirebaseManager(firebaseConfig, VAPID_KEY, userJson?.email)
          );
          setPermission(Notification.permission);
        }
      } catch (error) {
        console.error("Failed to check notification support:", error);
        setIsSupported(false);
      }
    };
    checkBrowserSupportNotification();
  }, [userJson?.email, isHomePage]);

  useEffect(() => {
    if (permission === "granted" && firebaseManager) {
      firebaseManager.registerServiceWorker((url) => url && navigate(url));
    }
  }, [permission, firebaseManager]);

  if (!isSupported || !isHomePage) return null;

  const handleClick = async () => {
    if (!firebaseManager) return;
    const notificationPermission = await Notification.requestPermission();
    if (notificationPermission === "granted") {
      firebaseManager.registerServiceWorker((url) => url && navigate(url));
    }
    setPermission(notificationPermission);
  };

  return (
    <>
      {permission && permission !== "granted" && (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="d-inline-block">
            Stay informed with real-time updates. Enable notifications for
            important alerts.
          </span>

          <>
            {permission === "denied" ? (
              <Popover
                arrowPointAtCenter
                placement="bottomRight"
                content={
                  <div className="menubar-icon-popover-content">
                    Please enable notifications in your{" "}
                    <strong>settings</strong> to stay updated!
                  </div>
                }
                overlayClassName="actioncard-popover"
                trigger="click"
                getPopupContainer={() => document.body}
              >
                <>
                  <PrimaryButton buttonText="Enable Notifications" />
                </>
              </Popover>
            ) : (
              <PrimaryButton
                buttonText="Enable Notifications"
                handleOnClick={handleClick}
              />
            )}
          </>
        </div>
      )}
    </>
  );
};

export default React.memo(EnableNotificationIcon);
